/*
  created by Rija
  added on 2/1/2021
  @desc meter main page to swtich between different options
*/

import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { ColorButton, EmptyStateContainer, FiltersContainer, HeadingContainer, RecordOptions, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import Avatar from '../../../../assets/images/module/general/userAvatar.svg';
import defaultAvatar from '../../../../assets/images/module/general/defaultAvatarPicture.svg';
import { withRouter } from 'react-router-dom';
import MessagingEditor from './MessagingEditor';
import { FormControl, IconButton, InputLabel, Select, TableContainer, MenuItem, Tooltip } from '@material-ui/core';
import { Checkbox, CheckboxGroup, Divider, Group, Loader, Popover, Radio, RadioGroup, Skeleton, Stack, Tooltip as MantineTooltip, CloseButton } from '@mantine/core';
import moment from 'moment';
import MessageTemplatesModal from '../../../../neoverv/components/Module/General/CustomModal/MessageTemplatesModal';
import breadcrumbsContent from '../../../../../src/assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import MessagesIcon from '../../../../assets/images/module/general/MessagesIcon.svg';
import YellowTick from '../../../../assets/images/module/general/YellowTick.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import ExplanationMarkIcon from '../../../../assets/images/module/general/ExplanationMarkIcon.svg';
import RightArrowPartner from '../../../../assets/images/module/general/RightArrowPartner.svg';
import { connect } from 'react-redux';
import { showNotification } from '@mantine/notifications';
import MessageDeleteModal from '../../../../neoverv/components/Module/General/CustomModal/MessageDeleteModal';
import { setPublishMessageId, setRefreshMessagesData } from '../../../../redux/action/General/generalActions';
import dayjs from 'dayjs';
import MessagePostviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePostviewModal';
import SelectMessageTypeModal from '../../../../neoverv/components/Module/General/CustomModal/SelectMessageTypeModal';
import BulkDownloadForMessageModal from '../../../../neoverv/components/Module/General/CustomModal/BulkDownloadForMessageModal';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import DownloadIcon from '../../../../assets/images/module/general/DownloadIcon.svg';
import Drawer from '../../../../neoverv/components/Module/General/Drawer/Drawer';
import FilterListIcon from '@material-ui/icons/FilterList';
import parse, { domToReact } from 'html-react-parser';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { checkProperty, loader, downloadDocument } = Autoload.MainHelper;

const MOBILE_SIZE = 992;

class MessagesList extends Component {
  state = {
    messageList: [{
        id: '0',
        title: 'Message 1',
        description: 'Lorem ipsum dolor sit amet, msg1 consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.',
        date: `${moment().format('DD-MM-YYYY')}T17:23:00`,
        tenant: [{
            name: 'Ten2',
            picture: defaultAvatar
        }]
    },
    {
        id: '1',
        title: 'Message 2',
        description: 'Lorem ipsum dolor sit amet, msg2 consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.',
        date: '13-04-2023T09:21:00',
        tenant: [{
            name: 'Ten4',
            picture: Avatar
        }, {
            name: 'Ten2',
            picture: defaultAvatar
        }, {
            name: 'Ten1',
            picture: Avatar
        }]
    },
    {
        id: '2',
        title: 'Message 3',
        description: 'Lorem ipsum dolor sit amet, msg3 consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.',
        date: '13-04-2023T12:10:00',
        tenant: [{
            name: 'Ten1',
            picture: defaultAvatar
        }]
    },
    {
        id: '3',
        title: 'Message 4',
        description: 'Lorem ipsum dolor sit amet, msg1 consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.',
        date: '12-04-2023T22:00:00',
        tenant: [{
            name: 'Ten1',
            picture: Avatar
        }, {
            name: 'Ten3',
            picture: defaultAvatar
        }]
    },
    {
        id: '4',
        title: 'Message 5',
        description: 'Lorem ipsum dolor sit amet, msg5 consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.',
        date: '12-04-2023T15:56:00',
        tenant: [{
            name: 'Ten1',
            picture: defaultAvatar
        }, {
            name: 'Ten2',
            picture: Avatar
        }, {
            name: 'Ten3',
            picture: defaultAvatar
        }, {
            name: 'Ten4',
            picture: Avatar
        }, {
            name: 'Ten5',
            picture: defaultAvatar
        }]
    }],
    search: '',
    openMessageTemplateModal: false,
    messagesList: [],
    skeletonLoading: false,
    fetch: 10, 
    offset: 0,
    stopOffsetChange: false,
    fetchLoader: false,
    openMessageDeletionModal: false,
    selectedMessageIdForDeletion: null,
    utilityBillings: [],
    openPropertyModal: false,
    isMobile: window.innerWidth <= MOBILE_SIZE,
    selectedMessageErrorPopover: null,
    openRecipientStatus: null,
    openPreviewModal: false,
    selectedRecipient: null,
    selectedMessage: null,
    openMessageTypeSelectionModal: false,
    openBulkMessageDownloadModal: false,
    selectedMessageForBulkDownload: null,
    selectedMessageType: null,
    openFilter: false,
    filters: {
      status: 'All'
    },
    openMessageStatusFilterPopover: false,
    filterOptions: {
      status: [
        {value: 'All', label: 'Alle'},
        {value: 'Draft', label: 'Entwurf'},
        {value: 'Publish', label: 'Gesendet'},
        {value: 'Failed', label: 'Fehler'},
      ]
    }
  };

  componentDidMount(){
    this.getMessages(true);
    document.addEventListener('scrollend', this.trackScrolling);
    this.getUtilityBillingsByPropertyId();

    console.log('this.props: ', this.props);
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(){
    const {selectedTenantId} = this.props;
    if(this.props.refreshMessagesData === true){
        this.props.setRefreshMessagesData(null);
        this.getMessage(this.props.publishMessageId);
    }

    if(this.props.openNewMessage === true){
      if(selectedTenantId){
        this.props.history.push('/messaging/newMessage', {
          tenantId: selectedTenantId,
          messageType: 'General',
          createNewTenantMessage: true,
          previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null
        });
      }else{
        this.setState({openMessageTemplateModal: true, selectedMessageType: 'General'});//this.setState({openMessageTypeSelectionModal: true});
      }

      this.props.setOpenNewMessage(false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scrollend', this.trackScrolling);
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // TODO: this causes data refetch on the meters reading details screen...
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  trackScrolling = () => {    
    const wrappedElement = document.getElementById('app-content');
    if (this.isBottom(wrappedElement) && !this.state.fetchLoader) {
      console.log('trackScrolling: ', this.state.messagesList.length, this.state.offset + this.state.fetch);
      //if(this.state.messagesList.length > (this.state.offset + this.state.fetch)){
        this.setState({
          offset: this.state.stopOffsetChange ? this.state.offset : this.state.offset + 10,
          fetchLoader: true}, ()=> this.getMessages()//this.getDocumentsByAccountId()//this.getDocumentsByAccountId()
        );
      //}
    }
  };

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  isTop(el) {
    return el.getBoundingClientRect().top <= window.innerHeight;
  }


  handleSearchHandler=(e)=>{
    this.setState({search: e.target.value});
  }

  getUtilityBillingsByPropertyId=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'utilityBillings?PropertyId=' + this.props.propertySelected.id,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetUtilityBillingsByPropertyId',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
  }

  handleGetUtilityBillingsByPropertyId(response){
    if(response.status && response.statuscode === 200){
        if(response.result.length > 0){
            this.setState({utilityBillings: response.result});
        }
    }
  }

  getMessages = (firstLoading=false) => {
    const {fetch, offset, filters} = this.state;
    const {selectedTenantId} = this.props;
    firstLoading && this.setState({skeletonLoading: true});
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + `messages/GetAllByProperty?propertyId=${this.props.propertySelected.id}&fetch=${fetch}&offset=${offset}${selectedTenantId ? `&tenantId=${selectedTenantId}` : ''}${filters.status !== 'All' ? `&messageStatus=${filters.status}` : ''}`,//GetAllByAccount
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetMessages',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleGetMessages(response){
    const {propertySelected, publishMessageId} = this.props;
    console.log('handleGetMessages: ', propertySelected);
    if(response.status && response.statuscode === 200){
        let propertyMessages = response.result.filter((message)=> message.propertyId === propertySelected.id);
      if(propertyMessages.length > 0){
        let {messagesList} = this.state;
        propertyMessages.map((message)=> {
            messagesList.push({...message, recipients: []});
        });
        this.setState({messagesList}, ()=> {
            if(publishMessageId){
                let messageStatus = messagesList.find((message)=> message.id === publishMessageId)?.status === 'Publish';
                if(messageStatus){
                    this.props.setPublishMessageId(null);
                }
            }
        });
        this.getMessageRecipientsByMessageIds(propertyMessages);
      }
    //   else{
    //     showNotification({message: 'none_found'});
    //   }
    }
    else if(!response.status && response.statuscode === 404 && response.message === 'Not Found'){
        this.setState({stopOffsetChange: true})
    }
    console.log('handleGetMessages: ', response);
    this.setState({skeletonLoading: false, fetchLoader: false});
  }

  getMessage= (id)=>{
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.user_reg_api_baseurl + `messages/${id}`,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetMessage',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
  }

  handleGetMessage(response){
    if(response.status && response.statuscode){
        let {messagesList} = this.state;
        messagesList = messagesList.map((message)=> {
            if(message.id === response.result.id){
                return {...response.result, recipients: message.recipients};
            }else{
                return message;
            }
        });
        this.setState({messagesList},()=> this.getMessageRecipientsByMessageIds([{id: response.result.id}]));
    }
    this.props.setPublishMessageId(null);
  }

  getMessageRecipientsByMessageIds=(messages)=>{
    Autoload.HttpRequestAxios.HttpRequest(
    Autoload.Setting.user_reg_api_baseurl + 'messageRecipients?'+ messages.map((message)=> `messageIds=${message.id}`).toString().replaceAll(',','&'),//`${this.state.messagesList.map((message)=> message.id)}`,
    'GET',
    null,
    null,
    false,
    true,
    false,
    this,
    'handleGettMessageRecipients',
    messages,
    false,
    '',
    {
        Authorization: Autoload.Utils.getAuthToken(),
    },
    true
    );
  }

  handleGettMessageRecipients(response){
    if(response.status && response.statuscode === 200){
        let {messagesList} = this.state;
        messagesList.map((message)=> {
            let newRecipients = response.result.filter((recipient)=> recipient.messageId === message.id);
            message.recipients = newRecipients.length > 0 ? newRecipients : message.recipients;
            return message;
        });
        this.setState({messagesList});
    }
    // else if(response.statuscode === 429){
    //     setTimeout(() => {
    //         this.getMessageRecipientsByMessageIds(response.other);  
    //     }, 3000);
    // }
  }

  deleteMessagesById = (id) => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messages/'+id,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteMessagesById',
      id,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleDeleteMessagesById(response){
    if(response.status && response.statuscode === 200){
        let {messagesList} = this.state;
        const index = messagesList.findIndex((message)=> message.id === response.other)
        console.log('handleDeleteMessagesById: ', index, response);
        if (index > -1) { 
            messagesList.splice(index, 1);
            this.setState({
                messagesList
            });
        }
    }
    this.setState({openMessageDeletionModal: false, selectedMessageIdForDeletion: null});
  }

  renderMessageBodyWithTooltips = (html, utilityBillingId = null) => {
    if (!html) return null;

    const { propertySelected, profile, accountData } = this.props;
    const { utilityBillings } = this.state;
    const selectedUtilityBilling = utilityBillings.find((ub) => ub.id === utilityBillingId);

    const placeholderMap = {
      'Abrechnungszeitraum': selectedUtilityBilling ? `${dayjs(selectedUtilityBilling.billingPeriod.startDate).format('DD.MM.YYYY')} - ${dayjs(selectedUtilityBilling.billingPeriod.endDate).format('DD.MM.YYYY')}` : null,
      'Absender': `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim(),
      'Eigentümer': propertySelected?.propertyOwner?.name || '',
      'Vermieter': accountData?.addressCompany || '',
      'Objektadresse': (propertySelected?.propertyAddress && propertySelected?.propertyZipCode && propertySelected?.propertyCity) ? `${propertySelected.propertyAddress}, ${propertySelected.propertyZipCode} ${propertySelected.propertyCity}` : null
    };

    const parseOptions = {
      replace: (domNode) => {
        if (domNode.name === 'a' && domNode.children && domNode.children.length > 0) {
          const innerText = domNode.children[0].data?.trim();
          
          if (innerText && Object.keys(placeholderMap).includes(innerText)) {
            const evaluatedValue = placeholderMap[innerText];

            return (
              <MantineTooltip 
                label={innerText} 
                position="top" 
                withinPortal 
                zIndex={9999999}
              >
                {/* FIX: Using a span guarantees React forwards the ref to Floating UI perfectly */}
                <span 
                  style={{ 
                    display: 'inline-block', 
                    cursor: 'pointer' 
                  }}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                >
                  <a>
                    {evaluatedValue ? evaluatedValue : innerText}
                  </a>
                </span>
              </MantineTooltip>
            );
          }
        }
      }
    };

    return parse(html, parseOptions);
  }

  // replaceAllPlaceHolders=(html, utilityBillingId=null)=>{
  //   const {propertySelected, profile, accountData} = this.props;
  //   const {utilityBillings} = this.state;
  //   let selectedUtilityBilling= utilityBillings.find((ub)=> ub.id === utilityBillingId);
  //   let newHtml= html;
  //   //let rentalUnit = rentalUnits.find((ru)=> ru.tenantsData.find((tenant)=> tenant.id === selectedRecipient.tenantId) !== undefined);
  //   if(selectedUtilityBilling){
  //     newHtml= newHtml.replaceAll('<a href="#" target="_self">Abrechnungszeitraum</a>', `<a href="#" target="_self">${dayjs(selectedUtilityBilling.billingPeriod.startDate).format('DD.MM.YYYY')} - ${dayjs(selectedUtilityBilling.billingPeriod.endDate).format('DD.MM.YYYY')}</a>`);
  //     newHtml= newHtml.replaceAll('<a href="" target="_self">Abrechnungszeitraum</a>', `<a href="" target="_self">${dayjs(selectedUtilityBilling.billingPeriod.startDate).format('DD.MM.YYYY')} - ${dayjs(selectedUtilityBilling.billingPeriod.endDate).format('DD.MM.YYYY')}</a>`);
  //   }

  //   newHtml= newHtml.replaceAll('<a href="#" target="_self">Absender</a>', `<a href="#" target="_self">${profile?.firstName || ''} ${profile?.lastName || ''}</a>`);
  //   newHtml= newHtml.replaceAll('<a href="" target="_self">Absender</a>', `<a href="" target="_self">${profile?.firstName || ''} ${profile?.lastName || ''}</a>`);

  //   newHtml= newHtml.replaceAll('<a href="#" target="_self">Eigentümer</a>', `<a href="#" target="_self">${propertySelected?.propertyOwner?.name || ''}</a>`);
  //   newHtml= newHtml.replaceAll('<a href="" target="_self">Eigentümer</a>', `<a href="" target="_self">${propertySelected?.propertyOwner?.name || ''}</a>`);

  //   newHtml= newHtml.replaceAll('<a href="#" target="_self">Vermieter</a>', `<a href="#" target="_self">${accountData?.addressCompany || ''}</a>`);
  //   newHtml= newHtml.replaceAll('<a href="" target="_self">Vermieter</a>', `<a href="" target="_self">${accountData?.addressCompany || ''}</a>`);

  //   if(propertySelected.propertyAddress && propertySelected.propertyZipCode && propertySelected.propertyCity){
  //     newHtml= newHtml.replaceAll('<a href="#" target="_self">Objektadresse</a>', `<a href="#" target="_self">${propertySelected.propertyAddress}, ${propertySelected.propertyZipCode} ${propertySelected.propertyCity}</a>`);
  //     newHtml= newHtml.replaceAll('<a href="" target="_self">Objektadresse</a>', `<a href="" target="_self">${propertySelected.propertyAddress}, ${propertySelected.propertyZipCode} ${propertySelected.propertyCity}</a>`);
  //   }
    
  //   //newHtml= newHtml.replaceAll('<a href="#" target="_self">Vorauszahlungen</a>', selectedBillingStatement?.totalAdvancePayments !== null && formatNumber(selectedBillingStatement?.totalAdvancePayments, true));
  //   console.log('newMessageData: ', newHtml);
  //   return newHtml;
  // }

  replaceValuesWithPlaceHolders=(html)=>{
    let newHtml= html;

    newHtml= newHtml.replaceAll('{{TENANT_OCCUPATION_BILLING_PERIOD}}', '<a href="#" target="_self">Abrechnungszeitraum</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ALLOCATED_UTILITY_COSTS}}', '<a href="#" target="_self">Betriebskosten</a>');
    newHtml= newHtml.replaceAll('{{BILLING_STATEMENT_BALANCE}}', '<a href="#" target="_self">Guthaben / Nachzahlung</a>');
    newHtml= newHtml.replaceAll('{{RECIPIENT_NAME}}', '<a href="#" target="_self">Empfänger</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_UNIT_NAME}}', '<a href="#" target="_self">Mieteinheit</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_STREET}}, {{PROPERTY_ZIPCODE}} {{PROPERTY_CITY}}', '<a href="#" target="_self">Objektadresse</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ADVANCE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlungen</a>');

    //new
    newHtml= newHtml.replaceAll('{{TENANT_NAME}}', '<a href="#" target="_self">Mieter</a>');
    newHtml= newHtml.replaceAll('{{USER_FIRST_NAME}} {{USER_LAST_NAME}}', '<a href="#" target="_self">Absender</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_OUT_DATE}}', '<a href="#" target="_self">Auszugsdatum</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_IN_DATE}}', '<a href="#" target="_self">Einzugsdatum</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_RECEIVED_RENT}}', '<a href="#" target="_self">erhaltene Miete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_EXPECTED_RENT_TOTAL}}', '<a href="#" target="_self">gesamte ausstehende Miete</a>');
    newHtml= newHtml.replaceAll('{{COLD_RENT}}', '<a href="#" target="_self">Kaltmiete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_MONTH}}', '<a href="#" target="_self">Mietmonat</a>');
    newHtml= newHtml.replaceAll('{{ACCOUNT_COMPANY_NAME}}', '<a href="#" target="_self">Vermieter</a>');
    newHtml= newHtml.replaceAll('{{RENT_PRE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlung</a>');
    newHtml= newHtml.replaceAll('{{WARM_RENT}}', '<a href="#" target="_self">Warmmiete</a>');

    newHtml= newHtml.replaceAll(`https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`, '<a href="#" target="_self">Zugangslink</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_OWNER_NAME}}', '<a href="#" target="_self">Eigentümer</a>');

    return newHtml;
  }

  renderNewMessageButton=()=>{
    const {selectedTenantId, formData} = this.props;
    return <ColorButton
    text={'Neue Nachricht'}
    className={'purple-btn'}
    onClick={()=> {
      // if(selectedTenantId){
      //   this.props.history.push('/messaging/newMessage', {
      //     tenantId: selectedTenantId,
      //     messageType: 'General',
      //     createNewTenantMessage: true,
      //     previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null
      //   });
      // }else{
        this.setState({openMessageTemplateModal: true, selectedMessageType: 'General'});//this.setState({openMessageTypeSelectionModal: true});
      // }
    }} //this.props.history.push('/messaging/newMessage')
    textStyle={{whiteSpace: 'nowrap'}}
    />
  }

  changePage(route, data) {
    if(route.includes('information')){
      let url = route+'?tenantId='+ this.state.tenantId;
      this.props.history.push(url, {
        ...data,
        unitId: checkProperty(this.props.history.location.state, 'unitId')
      });
    }else{
      this.props.history.push(route + '?tenant=' + Autoload.Utils.getUrlParameterByName('tenant'), {
        ...data,
        unitId: checkProperty(this.props.history.location.state, 'unitId')
      });
    }
  }

  handleChangeFilter=(value, name, applyFilters=false)=>{
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }), ()=>{
      if(applyFilters){
        this.setState({offset: 0, stopOffsetChange: false, messagesList: [], openFilter: false, openMessageStatusFilterPopover: false}, ()=> this.getMessages(true));
      }
    });
  }
  
  renderDrawer=()=>{
      const {openFilter, filters, fetchLoader} = this.state
      return (
        <Drawer open={openFilter} closeDrawer={()=> this.setState({openFilter: false})}>
          <Stack style={{padding: '10px', height: '100vh'}} justify='space-between'>
            <Stack gap={2}>
              <Group justify="space-between">
                <span className='documents-filter-title'>Nachrichten filtern</span>
                <IconButton size='medium'
                onClick={()=> this.setState({openFilter: false})}>
                  <CloseIcon style={{color: '#727293'}}/>
                </IconButton>
              </Group>
              <Divider/>  
              <Stack gap={0}>
                <div style={{margin: '15px'}}>
                  <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
                  <div style={{display: 'flex'}}>
                  <FormControl variant="outlined" style={{width: '100%'}}>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={filters.status}
                      style={{height: '40px', width: '100%'}}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left"
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left"
                        },
                        style: {zIndex: 10000000, height: '400px'},
                        getContentAnchorEl: null
                      }}
                      onChange={(e)=> this.handleChangeFilter(e.target.value, 'status', false)}
                      disabled={fetchLoader}
                    >
                      <MenuItem value={'All'}><span style={{fontStyle: 'italic'}} defaultValue>Alle</span></MenuItem>
                      <MenuItem value={'Draft'}>Entwurf</MenuItem>
                      <MenuItem value={'Publish'}>Gesendet</MenuItem>
                      <MenuItem value={'Failed'}>Fehler</MenuItem>
                    </Select>
                  </FormControl>
                  </div>
                </div>
              </Stack>
            </Stack>
            <div style={{margin: '5px', display: 'flex', justifyContent: 'space-between'}}>
                <ColorButton
                disabled={filters.status === 'All' || fetchLoader}  
                onClick={(e)=> this.handleReset(e)}
                className={"gray-btn"}
                text={'Zurücksetzen'}
                buttonStyle={{
                  cursor: filters.status === 'All' ? 'not-allowed' : 'pointer',
                  margin: '0 4px 0 4px'
                }}
                />
                <ColorButton
                onClick={()=> this.handleChangeFilter(filters.status, 'status', true)}
                className={"purple-btn"}
                text={'Übernehmen'}
                buttonStyle={{
                  margin: '0 4px 0 4px'
                }}
                />
            </div> 
          </Stack> 
        </Drawer>
      )
  }

  handleReset=(e)=>{
    e.preventDefault();
    this.setState({filters: {status: 'All'}, offset: 0, stopOffsetChange: false, messagesList: [], openFilter: false, openMessageStatusFilterPopover: false}, ()=>{
      this.getMessages(true);
    });
  }

  renderFilterButton=()=>{
      const {filters, openMessageStatusFilterPopover, filterOptions, isMobile} = this.state;
      return (
        <Popover
  opened={openMessageStatusFilterPopover}
  // 1. v7 uses onChange to handle clicking outside of controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ openMessageStatusFilterPopover: false });
  }}
  position="bottom-start" // 2. Combined position and placement
  withArrow={false}
>
  {/* 3. Target Wrapper */}
  <Popover.Target>
    <Group 
      className="selected-card-filter" 
      gap={7} 
      wrap="nowrap" 
      onClick={() => this.setState({ openMessageStatusFilterPopover: true })}
      style={{ marginBottom: isMobile ? '15px' : 0 }} // Moved from popover styles.root
    >
      <span style={{ whiteSpace: 'nowrap', maxWidth: isMobile ? '100px' : undefined, textOverflow: 'ellipsis', overflowX: 'hidden' }}>
        {`Status: ${filterOptions?.status?.find((option) => option.value === filters.status)?.label || filters.status}`}
      </span>
      {filters.status !== 'All' && (
        <Group>
          <CloseButton
            onMouseDown={(e) => this.handleReset(e)}
            variant="transparent"
            size={15}
            iconSize={14}
            tabIndex={-1}
          />
        </Group>
      )}
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="md">
    
    {/* 5. Replaces the old v4 Popover 'title' prop */}
    <div style={{ fontSize: '14px', fontWeight: 500, marginBottom: '15px' }}>
      Nachrichtenstatus auswählen
    </div>

    <Stack gap={30}>
      <Stack gap={15}>
        {/* 6. RadioGroup renamed to Radio.Group */}
        <Radio.Group
          value={filters.status}
          onChange={(value) => this.handleChangeFilter(value, 'status', false)}
        >
          {/* 7. Replaces orientation="vertical" */}
          <Stack gap="xs"> 
            {filterOptions.status.map((option) => (
              <Radio 
                key={option.value}
                value={option.value} 
                label={option.label}
                classNames={{
                  input: 'tenants-list-checkbox-rental-income-input', 
                  inner: 'tenants-list-checkbox-rental-income-inner'
                }}
                styles={{
                  label: {
                    fontSize: '14px',
                    marginBottom: 0
                  }
                }}
              />
            ))}
          </Stack>
        </Radio.Group>
      </Stack>
      
      <Group justify="space-between">
        <div>
          <ColorButton
            text="Abbrechen"
            className="gray-btn"
            onClick={(e) => this.handleReset(e)}
          />
        </div>
        <div>
          <ColorButton
            text="Anwenden"
            className="purple-btn"
            onClick={() => this.handleChangeFilter(filters.status, 'status', true)}
          />
        </div>
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>
      )
  }

  render() {
    const {messageList, search, openMessageTemplateModal, messagesList, skeletonLoading, fetchLoader, openMessageDeletionModal, selectedMessageIdForDeletion, utilityBillings, isMobile, selectedMessageErrorPopover, openRecipientStatus, openPreviewModal, selectedRecipient, selectedMessage, openMessageTypeSelectionModal, openBulkMessageDownloadModal, selectedMessageForBulkDownload, selectedMessageType} = this.state;
    const {propertySelected, publishMessageId, accountData, selectedTenantId} = this.props;
    console.log('messagesList: ', messagesList);
    console.log('utilityBillings: ', utilityBillings);
    console.log('propertySelected: ', propertySelected);
    console.log('isMobile: ', isMobile);
    return (
      <div className="messages-list-screen" style={{marginTop: selectedTenantId ? '20px' : '30px'}}>
        <FiltersContainer
            style={{marginBottom: isMobile && '0px'}}
            searchElement={
                <Stack style={{width: isMobile && '100%'}}>
                    <Group style={{width: isMobile ? '100%' : selectedTenantId ? '202px' : '330px'}} wrap="nowrap">
                        <SearchContainer
                        placeholder={selectedTenantId ? 'Nachrichten durchsuchen' : 'Inhalt, Empfänger'}
                        value={search}
                        onChange={this.handleSearchHandler}
                        disabled={false}
                        className={isMobile ? "mobile-annual-reading-search" : "annual-reading-search"}
                        />
                        {isMobile && 
                        <div>
                          {this.renderNewMessageButton()}
                        </div>}
                        {!isMobile && this.renderFilterButton()}
                    </Group>
                </Stack>
            }
            sortElement={!isMobile ? this.renderNewMessageButton() : this.renderFilterButton()}
        />
        {/* {!selectedTenantId && <div className="divider" style={{marginTop: isMobile && '0px'}}></div>} */}
        <div>
          <Stack>
            {skeletonLoading ?
            [...Array(5)].map((e, i) => <Skeleton visible={this.state.skeletonLoading} style={{height: '98px', marginBottom: '8px', zIndex: '1'}}/>)
            :
            Object.keys(propertySelected).length > 0 ?
                (messagesList.length > 0 ? 
                <Stack style={{marginBottom: '40px'}}>
                    {messagesList
                    .sort((a,b)=> moment(a.updatedOn).isBefore(moment(b.updatedOn)))
                    .filter((message)=> search !== '' ? (message.subject?.toLowerCase().includes(search.toLowerCase()) //|| message.tenant.find((ten)=> ten.name.toLowerCase().includes(search.toLowerCase())) !== undefined 
                    || message.body?.toLowerCase().includes(search.toLowerCase())) : message)
                    .map((message)=> {
                    let selectedRecipient = message?.recipients.find((recipient)=> recipient.tenantId === selectedTenantId);
                    const renderMessageBody = (body, utilityBillingId) => (
                      <span className={'message-card-description'}>
                        {selectedTenantId 
                          ? <span dangerouslySetInnerHTML={{__html: body}} /> 
                          : this.renderMessageBodyWithTooltips(this.replaceValuesWithPlaceHolders(body), utilityBillingId)
                        }
                      </span>
                    );
                    const renderEmptyMessageBody =()=> <span className={'message-card-description'}>{'(keine Nachricht)'}</span>;
                    const checkEmptyMessageBody =(body)=> (body !== null && body !== '<p></p>' && body !== '<p></p>\n' && body !== 0 && body !== '');

                    //const renderMessageSubject =(subject, utilityBillingId)=> <span style={{maxWidth: isMobile && (window.innerWidth - (moment(message.updatedOn).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? 255 : 225))}} className={`message-card-title ${isMobile && 'message-card-title-mobile'}`} dangerouslySetInnerHTML={{__html: selectedTenantId ? subject : this.replaceAllPlaceHolders(this.replaceValuesWithPlaceHolders(subject), utilityBillingId)}}></span>;
                    const renderMessageSubject = (subject, utilityBillingId) => (
                      <span 
                        style={{maxWidth: isMobile && (window.innerWidth - (moment(message.updatedOn).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? 255 : 225))}} 
                        className={`message-card-title ${isMobile && 'message-card-title-mobile'}`}
                      >
                        {selectedTenantId 
                          ? <span dangerouslySetInnerHTML={{__html: subject}} /> 
                          : this.renderMessageBodyWithTooltips(this.replaceValuesWithPlaceHolders(subject), utilityBillingId)
                        }
                      </span>
                    );
                    const renderEmptyMessageSubject =()=> <span style={{maxWidth: isMobile && (window.innerWidth - (moment(message.updatedOn).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? 255 : 225))}} className={`message-card-title ${isMobile && 'message-card-title-mobile'}`}>{'(kein Betreff)'}</span>;
                    const checkEmptyMessageSubject =(subject)=> (subject !== null && subject !== '<p></p>' && subject !== '<p></p>\n' && subject !== 0);
                    return (<Group 
                    key={`message-${message.id}`} 
                    align='flex-start' 
                    className={'message-card'} 
                    wrap="nowrap"
                    onClick={()=> {
                      if(message.id === publishMessageId){
                        showNotification({
                          message: 'Diese Nachricht kann nicht geöffnet werden, da sie gerade versendet wird. Sie können in wenigen Minuten auf die Nachricht zugreifen, wenn der Sendevorgang abgeschlossen ist.',
                          icon: <img src={YellowTick} alt='in-progress'/>
                        });
                      }else if(message.status === 'Draft'){
                        if(message.utilityBillingId){
                          this.props.history.push(`/utility-billing/utility?currentBillingId=${message.utilityBillingId}&ub-step=billing-statements-sending`, { isEdit: true });
                        }else{
                          this.props.history.push('/messaging/newMessage', {message: message, utilityBilling: utilityBillings.find((ub)=> ub.id === message.utilityBillingId), previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null});
                        }
                      }else if(openRecipientStatus === null){
                        if(selectedTenantId){
                          this.setState({openPreviewModal: true, selectedRecipient: selectedRecipient?.id, selectedMessage: message});
                          //this.changePage('messageDetail', {message: message, utilityBilling: utilityBillings.find((ub)=> ub.id === message.utilityBillingId)})
                        }else{
                          this.props.history.push('/messaging/messageDetail', {message: message, utilityBilling: utilityBillings.find((ub)=> ub.id === message.utilityBillingId)});
                        }
                      }
                    }}>
                        {/* {//message.tenant.length > 1 ?
                        // <Group gap={message.tenant.length <= 4 ? 2/message.tenant.length : 2/4} wrap="nowrap">
                        //     {message.tenant.map((ten, index)=>
                        //         index <= 3 && <img src={ten.picture} style={{minWidth: `${message.tenant.length <= 4 ? 64/message.tenant.length : 64/4}px`, width: `${message.tenant.length <= 4 ? 64/message.tenant.length : 64/4}px`}}/>
                        //     )}
                        // </Group>
                        // :
                        <Group>
                            <img src={Avatar} style={{minWidth: '64px', width: '64px', borderRadius: '50px', border: '1px solid #4949F5'}}/>
                        </Group>} */}
                        <Stack justify={'space-between'} style={{textOverflow: 'ellipsis', width: '100%', height: '100%'}}>
                            <Group style={{width: '100%'}} justify="space-between" wrap="nowrap">
                                <Group align={'center'} style={{height: '24px', flex: '1 1 auto', overflowY: 'auto', overflowX: 'hidden'}} gap={10} wrap="nowrap">
                                    <Group className={message.status === 'Failed' ? 'partner-list-row-tag-badge-failed' : 'partner-list-row-tag-badge'} wrap="nowrap" gap={5} style={{paddingRight: message.recipients.find((recipient)=> recipient.postalStatus === 'Failed' || recipient.emailStatus === 'Failed') !== undefined ? '2px' : '6px'}}>
                                        {message.status === 'Failed' ?
                                        <span>Fehler</span>
                                        :
                                        message.status === 'Draft' ?
                                          publishMessageId === message.id ?
                                          <Group gap={2} wrap="nowrap">
                                              <span style={{whiteSpace: 'nowrap'}}>Wird gesendet</span>
                                              <Loader type='dots' size={10} style={{marginTop: '5px'}} color='#5555FF' />
                                          </Group>
                                          :
                                          <span>Entwurf</span>
                                        :
                                        (message.status === 'Publish' || message.status === 'Sent') ?
                                        <span>Gesendet</span>
                                        : null}
                                        {message.recipients.find((recipient)=> recipient.postalStatus === 'Failed' || recipient.emailStatus === 'Failed') !== undefined &&
                                        <Popover
  opened={selectedMessageErrorPopover === message.id}
  // 1. Position und Placement werden kombiniert
  position="top-end"
  withArrow
>
  {/* 2. Target-Bereich */}
  <Popover.Target>
    <Group 
      onMouseEnter={() => this.setState({ selectedMessageErrorPopover: message.id })} 
      onMouseLeave={() => this.setState({ selectedMessageErrorPopover: null })}
    >
      <img style={{ minWidth: '16px' }} src={ExplanationMarkIcon} alt="Fehler" />
    </Group>
  </Popover.Target>

  {/* 3. Dropdown-Bereich mit leichtem Padding */}
  <Popover.Dropdown p="xs">
    {message.status === 'Failed' ? (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Fehler bei der Übermittlung der Nachricht aufgetreten. Die Nachricht konnte nicht gesendet werden. Wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    ) : (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Übertragungsfehler aufgetreten. Bitte prüfen Sie den Versandstatus und wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    )}
  </Popover.Dropdown>
</Popover>}
                                    </Group>
                                    {selectedTenantId ? checkEmptyMessageSubject(selectedRecipient?.subject) ? renderMessageSubject(selectedRecipient?.subject, message?.utilityBillingId) : renderEmptyMessageSubject() : checkEmptyMessageSubject(message?.subject) ? renderMessageSubject(message?.subject, message?.utilityBillingId) : renderEmptyMessageSubject()}
                                    {!isMobile &&
                                    <Group gap={10} style={{minWidth: '0px', overflowY: 'hidden'}} className='messages-list-recipients' wrap="nowrap">
                                        {message.recipients.sort((a,b)=> {
                                          if(selectedTenantId){
                                            if (a.tenantId === selectedTenantId) return -1;
                                            if (b.tenantId === selectedTenantId) return 1;
                                          }
                                          return a?.name?.localeCompare(b?.name);
                                        })
                                        .map((recipient, index)=>
                                        recipient.name &&
                                        <Popover
  opened={openRecipientStatus === recipient.id}
  position="top"
  withArrow
  transitionProps={{ duration: openRecipientStatus === null ? 1000 : 500 }} // 1. Grouped transition props
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Group 
      onClick={(e) => {
        const setOpenPreviewModal = () => this.setState({ openPreviewModal: true, selectedRecipient: recipient.id, selectedMessage: message });
        if (message.status !== 'Draft' && message.status !== 'Failed') {
          if (selectedTenantId) {
            if (selectedTenantId === recipient.tenantId) {
              setOpenPreviewModal();
            }
          } else {
            setOpenPreviewModal();
          }
        }
      }} 
      onMouseEnter={() => {
        const setOpenRecipientStatus = () => this.setState({ openRecipientStatus: recipient.id });
        if (message.status !== 'Draft') {
          if (selectedTenantId) {
            if (selectedTenantId === recipient.tenantId) {
              setOpenRecipientStatus();
            }
          } else {
            setOpenRecipientStatus();
          }
        }
      }} 
      onMouseLeave={() => message.status !== 'Draft' && this.setState({ openRecipientStatus: null })}
      gap={5} 
      className="message-card-ten-cards" 
      // 3. Merged the margins from the old root Popover into this Group's style object
      style={{
        marginLeft: index === 0 ? '12px' : undefined, 
        marginRight: index === (message.recipients.length - 1) ? '12px' : undefined,
        height: '20.6px', 
        maxHeight: '20.6px', 
        paddingRight: message.status !== 'Draft' ? '3px' : '10px', 
        opacity: selectedTenantId ? (recipient.tenantId === selectedTenantId ? 1 : 0.5) : 1, 
        cursor: selectedTenantId ? (recipient.tenantId === selectedTenantId ? 'pointer' : 'not-allowed') : 'pointer'
      }} 
      wrap="nowrap"
    >
      <Group style={{ background: '#454576', width: '18px', minWidth: '18px', borderRadius: '120px' }} justify="center" align="center" wrap="nowrap">
        <span style={{ textTransform: 'capitalize', color: 'white' }}>{recipient.name[0]}</span>
      </Group>
      <span style={{ whiteSpace: 'nowrap' }}>{recipient.name}</span>
      {message.status !== 'Draft' && (
        <Group>
          <img 
            style={{ minWidth: '16px' }} 
            src={(message.status === 'Failed' || (recipient.isPostEnabled && (recipient.postalStatus === 'Failed' || recipient.postalStatus === 'Verarbeitungsfehler')) || (recipient.isEmailEnabled && recipient.emailStatus === 'Failed')) ? ExplanationMarkIcon : (recipient.isPostEnabled && recipient.postalStatus === 'Publish') ? YellowTick : GreenTick}
            alt="Status Indicator"
          />
        </Group>
      )}
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="xs">
    {message.status === 'Failed' ? (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Fehler bei der Übermittlung der Nachricht aufgetreten. Die Nachricht konnte nicht gesendet werden. Wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    ) : (
      <Stack 
        gap={10} 
        style={{ fontSize: '12px', fontWeight: '400' }}
        onMouseEnter={() => this.setState({ openRecipientStatus: recipient.id })}
        onMouseLeave={() => this.setState({ openRecipientStatus: null })}
      >
        <Stack gap={10}>
          {recipient.isPostEnabled && (
            <Group gap={5}>
              <span>Briefversand:</span>
              {recipient.postalStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.postalStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.postalStatus === 'Verarbeitungsfehler' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.postalStatus === 'Failed' ? <span>Übertragungsfehler</span> : ''}
              {recipient.postalStatusMessage && <span>{recipient.postalStatusMessage}</span>}
            </Group>
          )}
          {recipient.isEmailEnabled && (
            <Group gap={5}>
              <span>Email-Versand:</span>
              {recipient.emailStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.emailStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.emailStatus === 'Error' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.emailStatus === 'Failed' ? <span>Übertragungsfehler</span> : recipient.emailStatus === 'Sent' ? 'Nachricht übermittelt' : ''}
            </Group>
          )}
          {recipient.isHiddenForTenantPortal === false && (
            <Group gap={5}>
              <span>Mieterportal:</span>
              <img src={GreenTick} alt="status" />
              <span>Nachricht übermittelt</span>
            </Group>
          )}
        </Stack>
        <Group onClick={() => this.setState({ openPreviewModal: true, selectedRecipient: recipient.id, selectedMessage: message })}>
          <span style={{ color: '#5555FF', cursor: 'pointer' }}>
            Empfängernachricht anzeigen <img src={RightArrowPartner} style={{ width: '12px', marginLeft: '2px' }} alt="arrow" />
          </span>
        </Group>
      </Stack>
    )}
  </Popover.Dropdown>
</Popover>)}
                                    </Group>}
                                </Group>
                                <Group wrap="nowrap">
                                    {<span className='message-card-time'>{moment(message.updatedOn).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? `heute (${moment(moment.utc(message.updatedOn).toDate()).local().format('LT')} Uhr)` : moment(message.updatedOn).format('DD.MM.YYYY')}</span>}
                                    {!isMobile && <RecordOptions
                                    className="delete-message"
                                    showEditButton={false}
                                    showDeleteButton={false}
                                    buttonStyle={{background: 'none', border: 'none', minWidth: '37px'}}
                                    listOfItems={message.status === 'Publish' ? [{
                                        text: <span style={{color: '#E8193C'}}>Löschen</span>,
                                        className: 'receipts-main-menu-dropdown-item',
                                        leftImage: <DeleteIcon style={{fontSize: '15px', color: '#E8193C'}}/>,
                                        openFunction: (()=> this.setState({openMessageDeletionModal: true, selectedMessageIdForDeletion: message.id}))
                                      },
                                      {
                                        text: 'PDF herunterladen',
                                        className: 'receipts-main-menu-dropdown-item',
                                        leftImage: <img src={DownloadIcon} width={'15px'} />,
                                        openFunction: (()=> message?.recipients?.length === 1 ? downloadDocument(message?.recipients[0], message) : this.setState({openBulkMessageDownloadModal: true, selectedMessageForBulkDownload: message}))
                                    }]
                                    : [{
                                        text: <span style={{color: '#E8193C'}}>Löschen</span>,
                                        className: 'receipts-main-menu-dropdown-item',
                                        leftImage: <DeleteIcon style={{fontSize: '15px', color: '#E8193C'}}/>,
                                        openFunction: (()=> this.setState({openMessageDeletionModal: true, selectedMessageIdForDeletion: message.id}))
                                    }]}
                                    />}
                                </Group>
                            </Group>
                            {selectedTenantId 
                            ? checkEmptyMessageBody(selectedRecipient?.body) ? renderMessageBody(selectedRecipient?.body, message?.utilityBillingId) : renderEmptyMessageBody() 
                            : checkEmptyMessageBody(message?.body) ? renderMessageBody(message?.body, message?.utilityBillingId) : renderEmptyMessageBody()}
                        </Stack>
                    </Group>)
                    })}
                    {fetchLoader &&
                    <Group style={{width: '100%'}} justify='center'>
                        <Loader type="dots" size={'md'} color={'#5555FF'}/>
                    </Group>}
                </Stack>
                :
                <EmptyStateContainer
                heading='Sie haben noch keine Nachrichten erstellt.'
                subheading={'Erstellte und gesendete Nachrichten werden hier angezeigt.'}
                icon={MessagesIcon}
                btnText={'Nachricht erstellen'}
                btnHandler={()=> this.setState({openMessageTemplateModal: true, selectedMessageType: 'General'})}//this.setState({openMessageTypeSelectionModal: true})}//this.setState({openMessageTemplateModal: true})}
                />)
            :
            <EmptyStateContainer
            heading='Sie haben noch keine Immobilie angelegt.'
            subheading={'Erstellte und gesendete Nachrichten werden hier angezeigt.'}
            icon={MessagesIcon}
            btnText={'Immobilie hinzufügen'}
            btnHandler={()=> this.props.history.push('/property')}//this.setState({openMessageTemplateModal: true})}
            />
            }
            
          </Stack>
        </div>
        {openMessageTemplateModal &&
        <MessageTemplatesModal
        open={openMessageTemplateModal}
        selectedTenantId={selectedTenantId}
        className={'template-modal'}
        selectedMessageType={selectedMessageType}
        history={this.props.history}
        toggle={()=> this.setState({openMessageTemplateModal: false, selectedMessageType: null})}
        openNewMessage={(templateSubject, templateBody, templateId)=> {
          console.log('openNewMessage: ', selectedTenantId);
          
          if(selectedTenantId){
            this.props.history.push('/messaging/newMessage', {
              tenantId: selectedTenantId,
              messageType: 'General',
              createNewTenantMessage: true,
              previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null,
              templateSubject, templateBody, templateId
            });
          }else{
            this.props.history.push('/messaging/newMessage', {messageType: 'General', templateSubject, templateBody, templateId});
          }
        }}
        
        />}
        {openMessageDeletionModal &&
        <MessageDeleteModal
        open={openMessageDeletionModal}
        toggle={()=> this.setState({openMessageDeletionModal: false, selectedMessageIdForDeletion: null})}
        onDelete={()=> this.deleteMessagesById(selectedMessageIdForDeletion)}
        />}

        {openPreviewModal &&
        <MessagePostviewModal
        open={openPreviewModal}
        toggle={()=> this.setState({openPreviewModal: false, selectedRecipient: null, selectedMessage: null})}
        isMobile={isMobile}
        allRecipients={selectedMessage.recipients}
        messageData={selectedMessage}
        senderAddress={(!accountData.addressCompany || !accountData.addressStreet || !accountData.addressZipCode || !accountData.addressCity) ? <span style={{color: '#dc3545', fontWeight: '500'}}>Absenderadresse unvollständig</span> : ` ${accountData.addressCompany+','} ${accountData.addressStreet+','} ${accountData.addressZipCode} ${accountData.addressCity}`}
        senderEmail={accountData.companyEmail}
        billingPeriod={null}
        selectedRecipient={selectedRecipient}
        selectedTenantId={selectedTenantId}
        />}

        {openMessageTypeSelectionModal &&
        <SelectMessageTypeModal
        open={openMessageTypeSelectionModal}
        toggle={()=> this.setState({openMessageTypeSelectionModal: false, selectedMessageType: null})}
        //createNewMessage={(messageType)=> this.props.history.push('/messaging/newMessage', {messageType})}
        createNewMessage={(messageType)=> this.setState({openMessageTemplateModal: true, selectedMessageType: messageType})}
        />}

        {openBulkMessageDownloadModal &&
        <BulkDownloadForMessageModal
        open={openBulkMessageDownloadModal}
        multipleTenants={[]}
        toggle={()=> this.setState({openBulkMessageDownloadModal: false, selectedMessageForBulkDownload: null})}
        allRecipients={selectedMessageForBulkDownload?.recipients}
        messageData={selectedMessageForBulkDownload}
        senderAddress={''}
        senderEmail={''}
        billingPeriod={''}
        isMobile={isMobile}
        postMessageDownload={true}
        />}
        {/* {this.renderDrawer()} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        currentDataId: state.UtilityBillingReducer.currentBillingId,
        propertySelected: state.generalReducer.property,
        rentalUnits: state.tenantDataReducer.rentalUnits,
        currentSubscription: state.generalReducer.currentSubscription,
        accountData: state.generalReducer.accountData,
        profile: state.generalReducer.profile,
        refreshMessagesData: state.generalReducer.refreshMessagesData,
        publishMessageId: state.generalReducer.publishMessageId,
        formData: state.tenantDataReducer.addEditFormData
    };
};

const actions = {
    setPublishMessageId, 
    setRefreshMessagesData
}
export default connect(mapStateToProps, actions)(MessagesList);
